module.exports = __webpack_public_path__ + "static/media/01A.83fcfd7b.png";